import { DatePipe } from '@angular/common';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';

import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ManualAwardsService } from 'src/app/gamification/command-center/services/manual-awards.service';

@Component({
    selector: 'cv-badges-earned',
    templateUrl: './badges-earned.component.html',
    styleUrls: ['./badges-earned.component.scss']
})
export class BadgesEarnedComponent implements OnInit, OnChanges, OnDestroy {
    @Input() awards: any;
    @ViewChild('badgesEarnedGrid') agGrid: AgGridAngular;

    mas = null;
    isDestroyed = false;
    awardsTable: GridOptions;
    localization = new Map();

    constructor(
        private datePipe: DatePipe,
        private manualAwardsService: ManualAwardsService,
        private cvLocalizationService: CVLocalizationService
    ) {
        this.mas = this.manualAwardsService.data;
        $(document).on('event_SelectedGroupsChanged', this.onGroupsChangedHandler);
    }

    ngOnInit(): void {
        this.loadLocalization();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.awards) {
            if (this.agGrid && this.agGrid?.api) {
                this.agGrid?.api.showLoadingOverlay();
                this.agGrid?.api.setGridOption('rowData', changes.awards.currentValue);
            }
        }
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }

    loadLocalization(): void {
        this.cvLocalizationService.GetSection("Gamification_Admin").then((map) => {
            this.localization = map;
            this.setupGrid();
        });
    }

    setupGrid(): void {
        this.awardsTable = {
            accentedSort: true,
            defaultColDef: {
                sortable: true,
                filter: true,
                resizable: true
            },

            columnDefs: [{
                field: 'Name',
                headerName: this.getColumnName('Badge_Name', 'Badge Name'),
                lockVisible: true,
                cellRenderer: (params) => {
                    var cellElement = '<div class="d-flex align-items-center h-100"><img class="rounded-circle mr-2" src="../Admin/ImageResizer.aspx?imgid=' + params.data.BadgeID + '&w=64&h=auto" style="width: 2.5rem;">';
                    cellElement += '<span>' + htmlEncode(params.value) + '</span></div>';

                    return cellElement;
                },
                minWidth: 250
            }, {
                field: 'DateCreated',
                headerName: this.getColumnName('Date_Created', 'Date Created'),
                type: 'numericColumn',
                cellRenderer: (params) => '<div class="d-flex align-items-center h-100 justify-content-end">' + this.datePipe.transform(params.value, CVAngularDateFormat) + '</div>'
            }, {
                field: 'FilteredAwardCount',
                headerName: this.getColumnName('Qty', 'Qty'),
                type: 'numericColumn',
                cellRenderer: (params) => '<div class="d-flex align-items-center h-100 justify-content-end">' + (params.value == undefined ? 0 : params.value) + '</div>',
                minWidth: 150
            }],

            rowHeight: 64,
            suppressDragLeaveHidesColumns: true,
            overlayLoadingTemplate: '<div class="loadView mt-5"></div>',

            getRowId: ({ data: rowData }) => {
                return rowData.RuleID;
            },

            onFirstDataRendered: (e) => {
                e.api.applyColumnState({ state: [{ "colId": "FilteredAwardCount", "sort": "desc" }] });
                e.api.sizeColumnsToFit();
            },

            onGridReady(e: GridReadyEvent) {
                e.api.sizeColumnsToFit();
            }
        };
    }

    getColumnName(key: string, defaultValue: string): string {
        if (this.localization && this.localization.has(key)) {
            return this.localization.get(key);
        }
        else { return defaultValue; }
    }

    onGroupsChanged(e: any): void {
        if (this.isDestroyed) {
            return;
        }

        this.manualAwardsService.countManualAwardsByFilter();

        if (this.agGrid && this.agGrid?.api) {
            this.agGrid?.api.showLoadingOverlay();
            this.agGrid?.api.setGridOption('rowData', this.mas.manualAwards);
            this.agGrid?.api.applyColumnState({ state: [{ colId: "FilteredAwardCount", sort: "desc" }] });
        }
    }

    private onGroupsChangedHandler = (e: any) => this.onGroupsChanged(e);
}
